module.exports = __webpack_public_path__ + "media/images/menu/metis-d2116678ac337ca4e2ad5a8d0192513f.jpg";